import { ReduxData } from '../../global/types'
import {
  TRIGGER_REQUEST,
  TRIGGER_REQUEST_SUCCESS,
  TRIGGER_REQUEST_ERROR,
  TriggerRequestAction,
  TriggerRequestSuccessAction,
  TriggerRequestErrorAction,
} from './actions'

export type RequestReduxState = {
  [id: string]: {
    isLoading: boolean
    error: string
    data: ReduxData
  }
}

export const reducer = (
  state: RequestReduxState = {},
  action:
    | TriggerRequestAction
    | TriggerRequestSuccessAction
    | TriggerRequestErrorAction,
) => {
  switch (action.type) {
    case TRIGGER_REQUEST: {
      return {
        ...state,
        ...{
          [action.id]: {
            isLoading: true,
            error: null,
            data: action.data,
          },
        },
      }
    }
    case TRIGGER_REQUEST_SUCCESS: {
      return {
        ...state,
        ...{
          [action.id]: {
            ...state[action.id],
            isLoading: false,
          },
        },
      }
    }
    case TRIGGER_REQUEST_ERROR: {
      return {
        ...state,
        ...{
          [action.id]: {
            ...state[action.id],
            isLoading: false,
            error: action.error,
          },
        },
      }
    }
    default:
      return state
  }
}
